import roles from "@/roles";
export default [
  {
    icon: "airplanemode_active",
    title: "Flights",
    roles: [roles.ADMIN, roles.FLIGHTS_ADMIN],
    children: [
      {
        icon: "access_alarm",
        router: true,
        roles: [roles.ADMIN, roles.FLIGHTS_ADMIN],
        title: "Hub Inbound Flights",
        to: "FlightAlerts"
      },
      {
        icon: "access_alarm",
        router: true,
        roles: [roles.ADMIN, roles.FLIGHTS_ADMIN],
        title: "Diverted/Canceled",
        to: "DivertedFlightAlerts"
      },
      {
        icon: "map",
        router: true,
        roles: [roles.ADMIN, roles.FLIGHTS_ADMIN],
        title: "Current Flights",
        to: "CurrentFlightsMap"
      }
    ]
  }
];
